import { render } from "./MainLayout2.vue?vue&type=template&id=5f2f45d3"
import script from "./MainLayout2.vue?vue&type=script&lang=js"
export * from "./MainLayout2.vue?vue&type=script&lang=js"

import "./MainLayout2.vue?vue&type=style&index=0&id=5f2f45d3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__